import React from "react";
import {Check} from "@sparkware/app-utils";
import {CyClass} from "../../../../../../common/cy-classes";
import {GREEN, RED} from "../css-constants";
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {ILiveTableInfo} from "../../../../../services/live-table-feeds-service/live-table-feeds.service.interface";
import {LiveCasinoGridItemDrawsBox} from "../boxes/infobar/draws/live-casino-grid-item-draws.box";
import {LiveCasinoGridItemDrawBox} from "../boxes/infobar/draws/live-casino-grid-item-draw.box";

interface IRouletteDrawsComponentProps {
    tableInfo: ILiveTableInfo;
}

const ROULETTE_NUMBERS_MAP = {
    red: [
       "1",  "3",  "5",  "7",  "9", "12",
      "14", "16", "18", "19", "21", "23",
      "25", "27", "30", "32", "34", "36"
    ],
    green: ["0", "00"]
    // Black numbers are implied by default, no need to map them
};

export class RouletteDrawsComponent extends OrbitComponent<IRouletteDrawsComponentProps> {

    private _getDrawColor(drawValue: string): string {

        if (ROULETTE_NUMBERS_MAP.red.includes(drawValue)) {
            return RED;
        } else if (ROULETTE_NUMBERS_MAP.green.includes(drawValue)) {
            return GREEN;
        }

        return null;
    }

    render() {

        if (Check.isEmpty(this.props.tableInfo) || this.props.tableInfo.BetBehind || !this.props.tableInfo.RouletteLast5Numbers || this.props.tableInfo.RouletteLast5Numbers.length === 0) {
            return null;
        }

        return (
            <LiveCasinoGridItemDrawsBox className={CyClass("cy-live-casino-grid-item-infobar-draws")}>
            {this.props.tableInfo.RouletteLast5Numbers.map((drawValue, i) =>
                <LiveCasinoGridItemDrawBox key={i} drawColor={this._getDrawColor(drawValue.toString())}>
                    <span>{drawValue}</span>
                </LiveCasinoGridItemDrawBox>
            )}
            </LiveCasinoGridItemDrawsBox>
        );
    }
}
